// ThemeContext.js
import React, { createContext, useContext, useState, useEffect } from 'react';
import { ThemeProvider as MuiThemeProvider, createTheme } from '@mui/material/styles';
import { getThemeOptions } from './theme';
import { useTranslation } from 'react-i18next';

const ThemeContext = createContext();

export const useThemeContext = () => useContext(ThemeContext);

export const ThemeProvider = ({ children }) => {
    const { i18n } = useTranslation();
    const [themeMode, setThemeMode] = useState(() => {
        const savedTheme = localStorage.getItem('themeMode');
        return savedTheme || 'light';
    });

    const theme = React.useMemo(() => {
        const direction = i18n.language === 'ar' ? 'rtl' : 'ltr';
        return createTheme({
            ...getThemeOptions(themeMode),
            direction,
        });
    }, [themeMode, i18n.language]);

    const toggleTheme = () => {
        const newMode = themeMode === 'light' ? 'dark' : 'light';
        setThemeMode(newMode);
        localStorage.setItem('themeMode', newMode);
    };

    useEffect(() => {
        const direction = i18n.language === 'ar' ? 'rtl' : 'ltr';
        document.documentElement.setAttribute('data-theme', themeMode);
        document.documentElement.dir = direction;
        document.documentElement.lang = i18n.language;
    }, [themeMode, i18n.language]);

    return (
        <ThemeContext.Provider value={{ themeMode, toggleTheme, theme }}>
            <MuiThemeProvider theme={theme}>
                {children}
            </MuiThemeProvider>
        </ThemeContext.Provider>
    );
};
